import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistleRegularStopSecondHalftime extends DomainEvent<MatchEvent> {}
